module.exports = __webpack_public_path__ + "img/bin-red.bc30fee3.svg";